import { LoadableAfterPaint } from '@confluence/loadable';
export { ContentTreeIcon } from '../src/ContentTreeIcon';

export const ContentTreeIconLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContentTreeIcon" */ '../src/ContentTreeIcon'))
			.ContentTreeIcon,
});
